import Header from '../Component/Header'
import Footer from '../Component/Footer'
import Breadcrumb from '../Component/Breadcrumb'
const withdrawal = () => {
    return (
        <>
            <Header />
            <Breadcrumb title="Procedure for Withdrawal" midBreadcrumb="Academic" mainBreadcrumb="Procedure for Withdrawal" ></Breadcrumb>
            <div className='inner-page'>
                <div className='container'>
                    <div className='row'>
                        <div className="col-12">
                            <h2 className="mainhead">Procedure for Withdrawal</h2>
                            <h3 className="subhead">Students can be withdrawn or removed from
                                the school as under:</h3>
                            <div className="media">
                                <div className="media-body">
                                    <p><strong>01.</strong> By giving a calendar Month’s notice in writing. In the absence of such a notice
                                        one month’s fee will be charged. </p>
                                </div>
                            </div>
                            <div className="media">
                                <div className="media-body">
                                    <p><strong>02.</strong> By the school authorities on one of
                                        the following grounds: </p>
                                    <ul className="list">
                                        <li>Constant weakness in studies.</li>
                                        <li>Irregularity in attendance.</li>
                                        <li>Behavior problem.</li>
                                        <li>Over-age in class.</li>
                                        <li>Non-payment of fees or chronic irregularity in payment
                                        </li>
                                        <li>Moral breach considered serious by the school
                                            committee</li>
                                        <li>Students who get married before completing Class X
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="media">
                                <div className="media-body">
                                    <p><strong>03.</strong> For withdrawal after April 30, fees for two months, i.e., May and June will have
                                        to be paid. Those who leave in November will have to pay the fees for December also.</p>
                                </div>
                            </div>
                            <div className="media">
                                <div className="media-body">
                                    <p><strong>04.</strong> A month’s written notice should be given before the withdrawal of a student T. C.
                                        will be issued only after receiving the notice. </p>
                                </div>
                            </div>
                            <div className="media">
                                <div className="media-body">
                                    <p><strong>05.</strong> No leave is sanctioned on test or examination days.</p>
                                </div>
                            </div>
                            <div className="media">
                                <div className="media-body">
                                    <p><strong>06.</strong> Those students who remain absent for more than 10 days without any leave
                                        application signed by the parents approved by the Principal, will be struck off from the school records.
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default withdrawal